//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BCarousel, BCarouselSlide } from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'
import {mapActions, mapState} from "vuex"

export default {

    name: 'Products',

    components: { BCarousel, BCarouselSlide, Multiselect },

    scrollToTop: true,

    data() {
        return {
            slide: 0,
            pageMeta: {},
            //countries: [],
            featuredProducts: {},
            //searchCountry: '',
            //searchCategory: '',
            //searchQuery: '',
            queryInput: '',
            detailProduct: {},
/*            categories: [
                { key: 'service', name: 'Service' },
                { key: 'product', name: 'Product' },
            ],*/
        }
    },

    head() {

        return this.$head()
            .setPage(this.pageMeta)
            .setBodyAttrs('products-body')
            .get()
    },

    filters: {
        limit: function (value, maxLength = 115) {
            if (value.length <= maxLength) return value;
            value = value.substr(0, maxLength -5) + '...';
            return value;
        }
    },


    created() {

        const params = this.getParamsQuery()

        if(params) {
            this.updateSearchParams(params)
        }

    },

    async asyncData({ $axios, $logger, $ziggy, store }) {

        let featuredProducts = {}, countries = {}, page = {}

        try {

            const response = await $axios.$get($ziggy.route('api.products.index'))

            featuredProducts = response.featuredProducts
            store.dispatch("products/updateCountries", response.countries)
            //page = resource.page

        } catch (e) {
            $logger.captureExceptionAxios(e)
        }

        return { featuredProducts }

    },


    methods: {

        ...mapActions('products', ['updateSearchQuery', 'updateSearchCategory', 'updateSearchCountry', 'clearSearchFilter', 'updateCountries', 'updateSearchParams']),

        openPopup(product) {
              this.$refs.child.openPopup(product)
        },

        onCountryChanged(value, id) {
            this.updateSearchCountry(value)
            this.onSearch()
        },

        onCategoryChanged(value, id) {
            this.updateSearchCategory(value)
            this.onSearch()
        },

        onQueryChanged() {

            if(this.$helper.empty(this.queryInput)) {
                return
            }

            if(this.searchQuery === this.queryInput) {
                this.queryInput = ''
                return
            }


            this.updateSearchQuery(this.queryInput)
            //this.searchQuery = this.queryInput
            this.queryInput = ''

            this.onSearch()

        },

        async onSearch() {

            const params = this.getParams()

            if(params === false) {
                this.clearFilter()
            } else {
                this.$router.push({ name: 'products.search', query: params })
            }

        },

        removeTag(type) {

            if(type === 'country') {
                this.updateSearchCountry('')
            }

            if(type === 'category') {
                this.updateSearchCategory('')
            }

            if(type === 'query') {
                this.updateSearchQuery('')
            }

            this.onSearch()

        },

        getParamsQuery() {

            let params = {
                country: '',
                category: '',
                query: '',
            }

            let valid = false

            if(this.$helper.empty(this.$route.query.country) === false) {
                params.country = this.$route.query.country.trim()
                valid = true
            }

            if(this.$helper.empty(this.$route.query.category) === false) {
                params.category = this.$route.query.category
                valid = true
            }

            if(this.$helper.empty(this.$route.query.query) === false) {
                params.query = this.$route.query.query
                valid = true
            }

            if(this.$helper.empty(this.$route.query.page) === false) {
                params.page = this.$route.query.page
                valid = true
            }

            if(valid === false) {
                return false
            }

            return params
        },

        getParams() {

            let params = {
                country: '',
                category: '',
                query: '',
            }

            let valid = false

            if(this.$helper.empty(this.searchCountry) === false && this.searchCountry.code) {
                params.country = this.searchCountry.code
                valid = true
            }

            if(this.$helper.empty(this.searchCategory) === false && this.searchCategory.key) {
                params.category = this.searchCategory.key
                valid = true
            }

            if(this.$helper.empty(this.searchQuery) === false) {
                params.query = this.searchQuery
                valid = true
            }

            if(valid === false) {
                return false
            }

            if(this.page > 1) {
                params.page = this.page
            }

            return params
        },

        clearFilter() {

            this.clearSearchFilter()

            const clearPath = '/products'

            if(this.$router.currentRoute.fullPath !== clearPath) {
                this.$router.push({ path: clearPath })
            }

        },

    },

    computed: {

        ...mapState('products', ['searchQuery', 'searchCategory', 'searchCountry', 'categories', 'countries']),

        isFilterSet() {

            if(this.$helper.empty(this.searchCountry) === false && this.searchCountry.code) {
                return true
            }

            if(this.$helper.empty(this.searchCategory) === false && this.searchCategory.key) {
                return true
            }

            if(this.$helper.empty(this.searchQuery) === false) {
                return true
            }

            return false
        },

        filterTags() {

            if(this.isFilterSet === false) {
                return false
            }

            let tags = []

            if(this.$helper.empty(this.searchCountry) === false && this.searchCountry.code) {
                tags.push({type: 'country', value: this.searchCountry.name})
            }

            if(this.$helper.empty(this.searchCategory) === false && this.searchCategory.key) {
                tags.push({type: 'category', value: this.searchCategory.name})
            }

            if(this.$helper.empty(this.searchQuery) === false) {
                tags.push({type: 'query', value: this.searchQuery})
            }

            return tags
        }

    }

}

